
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ContactHeroSection from './components/ContactHeroSection';
import ContactInfoSection from './components/ContactInfoSection';
import MapSection from './components/MapSection';
import DirectionsSection from './components/DirectionsSection';
import CallbackSection from './components/CallbackSection';
import FacilitiesSection from './components/FacilitiesSection';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ContactHeroSection />
        <ContactInfoSection />
        <MapSection />
        <DirectionsSection />
        <CallbackSection />
        <FacilitiesSection />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
